import { ArrowRightLeft } from 'lucide-react';

import { NodeShell } from './NodeShell';

import type { HandoffNodeData } from '@repo/shared-types';

export const HandoffNode = ({ data, selected }: { data: HandoffNodeData; selected?: boolean }) => {
  const subtitle = [
    data.configurationId ? data.configurationId.slice(0, 8) : null,
    `→ ${data.outputKey || 'handoff'}`,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <NodeShell
      type="handoff"
      icon={<ArrowRightLeft size={16} />}
      label={data.label}
      subtitle={subtitle}
      selected={selected}
    />
  );
};
